// Produtos Serequímica – catálogo visual estruturado
// Cada produto referencia a página do catálogo (jpg full + thumb).

export const CATEGORIES = [
  { id: "frigorificos", label: "Frigoríficos & Abatedouros", color: "#0e3b21" },
  { id: "metalmecanica", label: "Metalmecânica", color: "#0e3b21" },
  { id: "agro", label: "Agro & Implementos", color: "#0e3b21" },
];

export const PRODUCTS = [
  // ————————— FRIGORÍFICOS —————————
  {
    id: "dac-detergente",
    category: "frigorificos",
    name: "DAC Detergente Alcalino Clorado",
    tag: "Higienização Profissional",
    short: "Remove gorduras, proteínas e desinfecta pisos, paredes, balcões, equipamentos e utensílios.",
    features: ["Poder de limpeza profunda", "Desinfecção eficaz", "Espuma ativa", "Uso profissional"],
    thumb: "/assets/products/frig-p2-thumb.jpg",
    full: "/assets/products/frig-p2.jpg",
  },
  {
    id: "detergente-premium",
    category: "frigorificos",
    name: "Detergente Premium",
    tag: "Detergente Neutro",
    short: "Neutro para limpeza de equipamentos em geral, abatedouros e frigoríficos.",
    features: ["Diluição flexível", "Pronto uso", "Uso profissional"],
    thumb: "/assets/products/frig-p3-thumb.jpg",
    full: "/assets/products/frig-p3.jpg",
  },
  {
    id: "desincrust-acido-amazonas-frig",
    category: "frigorificos",
    name: "Desincrustante Ácido Amazonas",
    tag: "Remoção de Incrustações",
    short: "Remove minerais, oxidativos, oleosidade e manchas em cimento e pisos industriais.",
    features: ["Ação ácida controlada", "Desincrusta tanques", "Diluição 1/5 – 1/10"],
    thumb: "/assets/products/frig-p3-thumb.jpg",
    full: "/assets/products/frig-p3.jpg",
  },
  {
    id: "desengordurante-gr",
    category: "frigorificos",
    name: "Desengordurante GR",
    tag: "Alto Poder Desengordurante",
    short: "Produto alcalino para remoção de sujidades pesadas em chapa, coifa, grelha e bancada.",
    features: ["Alcalino", "Pronto uso", "Superfícies engorduradas"],
    thumb: "/assets/products/frig-p4-thumb.jpg",
    full: "/assets/products/frig-p4.jpg",
  },
  {
    id: "desengraxante-alcalino-sh",
    category: "frigorificos",
    name: "Desengraxante Alcalino SH",
    tag: "Indústria Alimentícia",
    short: "Limpador, desengraxante e desengordurante industrial para equipamentos laváveis.",
    features: ["Gerador de espuma", "Diluição 1/10", "Alimentício"],
    thumb: "/assets/products/frig-p4-thumb.jpg",
    full: "/assets/products/frig-p4.jpg",
  },
  {
    id: "hipoclorito-sodio",
    category: "frigorificos",
    name: "Hipoclorito de Sódio 12%",
    tag: "Sanitização Profissional",
    short: "Solução eficiente para higienização e esterilização de frigoríficos e abatedouros.",
    features: ["Diluição 0,1% – 0,5%", "Ação rápida (10 min)", "Uso profissional"],
    thumb: "/assets/products/frig-p5-thumb.jpg",
    full: "/assets/products/frig-p5.jpg",
  },
  {
    id: "peroxido-hidrogenio",
    category: "frigorificos",
    name: "Peróxido de Hidrogênio 50%",
    tag: "Agente de Esterilização",
    short: "Esterilização e higienização com máxima eficácia por vaporização (VPH) ou plasma.",
    features: ["Vaporização (VPH)", "Plasma", "Alta eficácia"],
    thumb: "/assets/products/frig-p6-thumb.jpg",
    full: "/assets/products/frig-p6.jpg",
  },

  // ————————— METALMECÂNICA —————————
  {
    id: "descarbonizante",
    category: "metalmecanica",
    name: "Descarbonizante Líquido",
    tag: "Manutenção de Motores",
    short: "Descontaminação profunda de cabeçotes, blocos e bombas injetoras — imersão total 45 min.",
    features: ["Alto poder de penetração", "Recupera eficiência térmica", "Uso profissional"],
    thumb: "/assets/products/metal-p2-thumb.jpg",
    full: "/assets/products/metal-p2.jpg",
  },
  {
    id: "abrilhantador",
    category: "metalmecanica",
    name: "Abrilhantador",
    tag: "Manutenção de Motores",
    short: "Descontaminação mineral e ativação de brilho em ligas de alumínio. Ação em 30 segundos.",
    features: ["Base ácida", "Padrão superior de acabamento", "Custo-benefício"],
    thumb: "/assets/products/metal-p3-thumb.jpg",
    full: "/assets/products/metal-p3.jpg",
  },
  {
    id: "oleo-soluvel-sintetico",
    category: "metalmecanica",
    name: "Óleo Solúvel Sintético",
    tag: "Usinagem CNC",
    short: "Fluido de corte sintético refrigerante e lubrificante para processos de usinagem de precisão.",
    features: ["Anticorrosivo", "Estabilidade de emulsão", "CNC / vibratórios"],
    thumb: "/assets/products/metal-p4-thumb.jpg",
    full: "/assets/products/metal-p4.jpg",
  },
  {
    id: "antirrespingo-mig",
    category: "metalmecanica",
    name: "Antirrespingo Líquido para Solda MIG",
    tag: "Soldagem",
    short: "Elimina o retrabalho pós-solda impedindo aderência de metal fundido em peças e tochas.",
    features: ["Fácil remoção", "Aplicação técnica", "Bicos de tocha e peça"],
    thumb: "/assets/products/metal-p5-thumb.jpg",
    full: "/assets/products/metal-p5.jpg",
  },
  {
    id: "desengraxante-alcalino-metal",
    category: "metalmecanica",
    name: "Desengraxante Alcalino",
    tag: "Preparação de Superfície",
    short: "Remove óleos e graxas leves de superfícies contaminadas em processos industriais pesados.",
    features: ["Alto desempenho", "Diluição 1/10", "Oficinas mecânicas / agrícolas"],
    thumb: "/assets/products/metal-p6-thumb.jpg",
    full: "/assets/products/metal-p6.jpg",
  },
  {
    id: "fosfatizante",
    category: "metalmecanica",
    name: "Fosfatizante",
    tag: "Preparação de Superfície",
    short: "Tripla ação: desengraxante, decapante e fosfatizante — ideal antes de pintura.",
    features: ["Base fosfórica", "Anticorrosivo", "Ancoragem para pintura"],
    thumb: "/assets/products/metal-p7-thumb.jpg",
    full: "/assets/products/metal-p7.jpg",
  },

  // ————————— AGRO —————————
  {
    id: "amazonas-cap-cb",
    category: "agro",
    name: "Amazonas Cap CB 1/10",
    tag: "Detergente Desincrustante Ácido",
    short: "Concentrado para pré-lavagem de chassis, partes baixas e superfícies metálicas encardidas.",
    features: ["Ação ácida potente", "Alta eficiência", "Uso profissional"],
    thumb: "/assets/products/agro-p2-thumb.jpg",
    full: "/assets/products/agro-p2.jpg",
  },
  {
    id: "solupan-automotivo",
    category: "agro",
    name: "Solupan Amazonas Automotivo",
    tag: "Detergente Alcalino Automotivo",
    short: "Pré-lavagem alcalina para veículos e partes baixas — remove óleos, graxas e sujeiras pesadas.",
    features: ["Alto poder desengraxante", "Fórmula alcalina", "Diluição até 1/20"],
    thumb: "/assets/products/agro-p5-thumb.jpg",
    full: "/assets/products/agro-p5.jpg",
  },
  {
    id: "tankclear-tc-agro",
    category: "agro",
    name: "Tankclear TC Agro",
    tag: "Limpeza de Tanques de Pulverização",
    short: "Detergente concentrado para limpeza e conservação de tanques — inclui drones agrícolas.",
    features: ["Tensoativo biodegradável", "Ação desincrustante", "Sequestrante"],
    thumb: "/assets/products/agro-p3-thumb.jpg",
    full: "/assets/products/agro-p3.jpg",
  },
  {
    id: "desincrust-acido-amazonas-agro",
    category: "agro",
    name: "Desincrustante Ácido Amazonas",
    tag: "Barras de Pulverização",
    short: "Limpeza de barras de pulverização — remove minerais, ferrugem, óxidos e incrustações.",
    features: ["Remove ferrugem", "Ação ácida controlada", "Conserva o equipamento"],
    thumb: "/assets/products/agro-p4-thumb.jpg",
    full: "/assets/products/agro-p4.jpg",
  },
  {
    id: "oleo-protetivo-prot220",
    category: "agro",
    name: "Óleo Protetivo PROT220",
    tag: "Proteção Anticorrosiva",
    short: "Proteção anticorrosiva e lubrificante para peças metálicas — 3 a 6 meses de proteção.",
    features: ["Sem solventes ofensivos", "Aplicação versátil", "Proteção prolongada"],
    thumb: "/assets/products/agro-p6-thumb.jpg",
    full: "/assets/products/agro-p6.jpg",
  },
  {
    id: "oleo-soluvel-blue",
    category: "agro",
    name: "Óleo Solúvel Blue",
    tag: "Fluido de Usinagem",
    short: "Fluido sintético bio-estável para usinagem de perfis e trefilados ferrosos e não ferrosos.",
    features: ["Bio-estável", "Alta tecnologia", "Proteção contra corrosão"],
    thumb: "/assets/products/agro-p7-thumb.jpg",
    full: "/assets/products/agro-p7.jpg",
  },
  {
    id: "anti-respingo-cb",
    category: "agro",
    name: "Anti Respingo CB",
    tag: "Soldagem em Implementos",
    short: "Fluido de antiaderência de respingos com silicone para operações de solda em implementos.",
    features: ["Evita aderência", "Aplicação prática", "Manutenção de solda"],
    thumb: "/assets/products/agro-p8-thumb.jpg",
    full: "/assets/products/agro-p8.jpg",
  },
];
